import { useTranslation } from 'react-i18next'

export function useT() {
  const { t, i18n } = useTranslation()
  return {
    t,
    lang: i18n.language,
    changeLang: (lng: string) => {
      i18n.changeLanguage(lng)
      localStorage.setItem('app_language', lng)
    },
  }
}
